<template>
  <div>

    <van-tabs v-model="activeName" swipeable>

      <van-tab style="margin-top:15px; padding-left:15px" :title="depo_alias" name="0">

        <van-sticky :offset-top="50">
          <van-field v-model="value1" left-icon="filter-o" right-icon="warning-o" :placeholder="depo_alias+' içinde stok ara'" />
        </van-sticky>

          <!-- <van-pull-refresh v-model="isLoading" @refresh="onLoad">-->
            <div v-for="(item,index) in filteredList" :key="index" >
              <van-panel @click="numeric(item.marka,item.sto_isim,item.sto_kod,item.fiyat)" :title="item.sto_isim" :desc="item.marka+'-'+item.sto_kod" :status="item.adet+' Adet'">
                </van-panel>
              <!--<van-swipe-cell>
                
                 <template #left>
                    <van-button square type="danger" text="Adetler" @click="stokadet(item.sid)"/>
                  </template>
                  <template #right>
                    <van-button square type="primary" text="Sepete Ekle" @click="numeric(item.marka,item.sto_isim,item.sto_kod)"/>
                  </template>
              </van-swipe-cell>-->
            </div>
          <!-- </van-pull-refresh>-->


      </van-tab>
      <van-tab style="margin-top:15px; padding-left:15px" title="Servis Sepeti" name="1">

            <van-pull-refresh v-model="isLoading" @refresh="sepetgetir"> 
            <div v-for="(item,index) in sepet" :key="index" >
              <van-panel @click="kaldir(item.id,item.adet,item.isim)" :title="item.isim" :desc="item.stid" :status="item.adet+' Adet'">
              </van-panel>
            </div>
          </van-pull-refresh>

      </van-tab>

    </van-tabs>


        <div style="height:70px"></div>
        <van-tabbar v-model="active">
          <van-tabbar-item name="servis" to="/servis" icon="wap-home-o">Servis</van-tabbar-item>
          <van-tabbar-item name="detay" :to="`/servis/${id*8589}`" icon="home-o">Genel</van-tabbar-item>
          <van-tabbar-item name="islem" :to="`/islem/${id*8589}`" icon="notes-o">İşlem</van-tabbar-item>
          <van-tabbar-item name="stok" :to="`/stok/${id*8589}`" icon="points">Stok</van-tabbar-item>
          <van-tabbar-item name="matbuu" :to="`/matbuu/${id*8589}`" icon="photo-o">Matbuu</van-tabbar-item>
          <van-tabbar-item name="cihaz" :to="`/cihaz/${id*8589}`" icon="fire-o">Cihaz</van-tabbar-item>
        </van-tabbar>
        <van-popup id="456" v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>

<van-number-keyboard
  :show="keyshow"
  theme="custom"
  extra-key="."
  close-button-text="EKLE"
  :delete-button-text=adet
  title="Sepete Ekle"
  v-model="adet"
  @blur="keyshow = false;"
  @close="sepetekle"
  @input="adetekle"
  
/>

  </div>
</template>

<script>
import { Notify } from 'vant';
import { Dialog } from 'vant';
import { Popup } from 'vant';
import { decode } from 'js-base64';
export default {
  data() {
    return {
      activeName:0,
      id:this.$route.params.id/8589,
      list:[],
      error:[],
      donem: this.$request.donem(),
      ayar:this.$request.ayar(),
      active:'stok',
      show:false,
      keyshow:false,
      value1:'',
      adet:'',
      stokname:'',
      stokid:'',
      fiyat:0,
      isLoading: false,
      sepet:[],
      popshow:false,
      depo:[],
      depo_kod:'',
      depo_alias:'',
      kisa:decode(this.$request.ayar().genel.s),
    };
  },
  computed:{
    filteredList() {
      return this.list.filter(post => {
        return post.sto_isim.toLowerCase().includes(this.value1.toLowerCase())
      })
    }    
  },
  created(){
    this.show = true
    this.depobul(this.onLoad)
  },

  methods: {
        depobul(callback){
          this.$request.get("servis/depogetir/"+this.id)
            .then(res=> {
                let depo=res.results[0].depo_kod.split('#');
                this.depo=res.results[0].depo_kod
                this.depo_kod = depo[0]
                this.depo_alias = depo[1]
                callback(depo[0]);
            })
            
        },

        //  onLoad() {
          
        //     this.$request.get("depo/stok/"+this.ayar.firmaid+"/"+this.$request.did())
        //     .then(res => {this.list = res.results
        //     this.sepetgetir()
        //     this.isLoading = false;

        //     })
        // },
        onLoad(kod) {
            
            this.$request.get("servis/stoklar/"+kod)
            .then(res => {this.list = res.data.data
            this.sepetgetir()
            this.isLoading = false;
            this.show= false
            
            })
        },

        sepetgetir() {
          
            this.$request.get("servis/icsepetmikro/"+this.id)
            .then(res => {this.sepet = res.results
            this.show = false;
            this.isLoading = false;

            })
        },
        kaldir(stid,adet,isim) {
            Dialog.confirm({
            title: isim+' '+adet+' Adet Silinecek',
            message: 'Onaylıyormusnuz ?',
          })
            .then(() => {
          this.show = true
            this.$request.get("servis/sepet/delete/"+this.id+"/"+stid)
            .then(() => {
              Notify({ type: 'danger', message: 'Başarılı...' });
              this.sepetgetir()})
              })
        },
        aktar(id,adet,name,marka){

          Dialog.confirm({
            title: marka+' '+name +' '+adet+' Adet',
            message: 'Onaylıyormusnuz ?',
          })
            .then(() => {

                    this.show = true
                      let newpost = {
                          stid : id,
                          adet : adet,
                          evrakno : this.id,
                          tip : 0,
                          fiyat : 0,
                          firma : this.ayar.firmaid,
                          depo:this.$request.did(),
                          kid:this.ayar.kid
                      }
                      this.$request.post("stok_hareket", newpost)
                      .then(res => {
                        Notify({ type: 'success', message: 'Aktarıldı...' })
                        this.kaldir(res.data)
                      })
                      .catch(err => { Notify({ type: 'danger', message: 'Hata...' });
                      this.sepetgetir()
                      })
          })
          .catch(() => {

          Notify({ type: 'danger', message: 'Ürün Sepette...' })
        });

        } ,

        numeric(marka,isim,id,fiyat) {
          this.stokname = isim +' - '+marka
          this.stokid = id
          this.keyshow = true
          this.adet = ''
          this.fiyat = fiyat
        },
        sepetekle(){
            Dialog.confirm({
            title: this.stokname +' '+this.adet+' Adet',
            message: 'Onaylıyormusnuz ?',
          })
            .then(() => {      
          this.show = true
          let newPost = {
             sid:this.id,
             stid:this.stokid,
             adet:this.adet,
             kid:this.ayar.kid,
             depo:this.depo_alias,
             isim:this.stokname,
             mikrofiyat:this.fiyat,
             depokod:this.depo_kod
          }
           this.$request.post("servis/sepet/",newPost)
           .then(() => {
             
             Notify({ type: 'success', message: 'Eklendi...' });
             this.sepetgetir()
             this.show = false
           })
           .catch(() => {Notify({ type: 'danger', message: 'Hata...' });})

           })
        },
        adetekle(value){
           this.adet = this.adet+''+value
        },
        onChange(index) {
          //this.active = index+1;
        },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/servis/stok.vue